import { IServerSideDatasource } from "ag-grid-community";
import { GetMyPosition } from "../services/PositionService";

export class CustomServerSideDatasource implements IServerSideDatasource {
  baseUrl: any;
  entitySet: any;
  columns: any;
  countFnName: any;
  constructor(baseUrl: any, entitySet: any, columns: any, countFnName: any) {
    this.baseUrl = baseUrl;
    this.entitySet = entitySet;
    this.columns = columns.map((column: any) => column.field);
    this.countFnName = countFnName;
  }

  getRows(params: any): void {
    const { request } = params;
    console.log("request", request);

    const { startRow, endRow, filterModel, sortModel } = request;

    const filterParams = Object.keys(filterModel).map((key) => {
      console.log(filterModel[key]);

      const { type, filter, operator, condition1, condition2 } =
        filterModel[key];
      console.log(operator);
      if (operator === undefined) {
        if (type === "contains") {
          return `contains(${key},'${filter}') `;
        } else if (type === "notContains") {
          return `not contains(${key},'${filter}') `;
        } else if (type === "equals") {
          return `${key} eq '${filter}'`;
        } else if (type === "notEqual") {
          return `${key} ne '${filter}'`;
        } else if (type === "startsWith") {
          return `startswith(${key},'${filter}') `;
        } else if (type === "endsWith") {
          return `endsWith(${key},'${filter}') `;
        } else if (type === "blank") {
          return `(${key} eq '${null}' or ${key} eq '${""}' )`;
        } else if (type === "notBlank") {
          return `(${key} ne '${null}' or ${key} ne '${""}' )`;
        }
      } else {
        let filters = "";
        if (condition1.type === "contains") {
          filters = filters + `contains(${key},'${condition1.filter}') `;
        } else if (condition1.type === "notContains") {
          filters = filters + `not contains(${key},'${condition1.filter}') `;
        } else if (condition1.type === "equals") {
          filters = filters + `${key} eq '${condition1.filter}'`;
        } else if (condition1.type === "notEqual") {
          filters = filters + `${key} ne '${condition1.filter}'`;
        } else if (condition1.type === "startsWith") {
          filters = filters + `startswith(${key},'${condition1.filter}') `;
        } else if (condition1.type === "endsWith") {
          filters = filters + `endsWith(${key},'${condition1.filter}') `;
        } else if (condition1.type === "blank") {
          filters = filters + `(${key} eq '${null}' or ${key} eq '${""}' )`;
        } else if (condition1.type === "notBlank") {
          filters = filters + `(${key} ne '${null}' or ${key} ne '${""}' )`;
        }

        // start condition 2

        if (condition2.type === "contains") {
          filters =
            filters + ` ${operator} contains(${key},'${condition2.filter}') `;
        } else if (condition2.type === "notContains") {
          filters =
            filters +
            ` ${operator} not contains(${key},'${condition2.filter}') `;
        } else if (condition2.type === "equals") {
          filters = filters + ` ${operator} ${key} eq '${condition2.filter}'`;
        } else if (condition2.type === "notEqual") {
          filters = filters + ` ${operator} ${key} ne '${condition2.filter}'`;
        } else if (condition2.type === "startsWith") {
          filters =
            filters + ` ${operator} startswith(${key},'${condition2.filter}') `;
        } else if (condition2.type === "endsWith") {
          filters =
            filters + ` ${operator} endsWith(${key},'${condition2.filter}') `;
        } else if (condition2.type === "blank") {
          filters =
            filters +
            ` ${operator} (${key} eq '${null}' or ${key} eq '${""}' )`;
        } else if (condition2.type === "notBlank") {
          filters =
            filters +
            ` ${operator} (${key} ne '${null}' or ${key} ne '${""}' )`;
        }
        //console.log(filters);

        return filters;
      }

      return `${key} ${type} '${filter}'`;
    });

    const sortParams = Object.keys(sortModel).map((key) => {
      const { sort, colId } = sortModel[key];
      return `${colId} ${sort}`;
    });

    const filter = filterParams.join(" and ");
    const sort = sortParams.join(",");
    let url = `${this.baseUrl}/${this.entitySet}?$select=${this.columns.join(
      ","
    )}&$top=${endRow - startRow}&$skip=${startRow}`;

    if (filter !== "") {
      url = url + `&$filter=${filter}`;
    }

    if (sort !== "") {
      url = url + `&$orderby=${sort}`;
    }

    async function GetMyPositionAsync() {
      await GetMyPosition().then((p) => {
        if (p.data) {
          fetch(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              UserPositionId: p.data.id,
            },
          })
            .then((response) => response.json())
            .then((data) => {
              const rowCount = data["@odata.count"];
              params.successCallback(data.value, rowCount);
            })
            .catch((error) => {
              console.error(error);
              params.failCallback();
            });
        }
      });
    }
    // this is where we say what position it is .
    GetMyPositionAsync();
  }
}
